module.exports = __webpack_public_path__ + "b6c7f5664c94cc5db624b26c2d1fd054.png";